import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import Accordion from '@components/common/Accordion/Accordion';

import type { equipmentsTypeNames } from '../../constants/equipmentsTypeNames';
import type { IHardwareOverviewDetailsEquipmentLocations } from '../../model/hardwareOverviewDetails';
import EquipmentCard from '../EquipmentCard/EquipmentCard';
import style from './style.module.scss';

interface IProps {
  keyData: keyof typeof equipmentsTypeNames;
  equipmentsListByLoc: Array<IHardwareOverviewDetailsEquipmentLocations>;
}

const HardwareEquipmentsByLoc: React.FC<IProps> = ({ keyData, equipmentsListByLoc }) => {
  if (!equipmentsListByLoc.length) {
    return null;
  }

  return equipmentsListByLoc.map((location) => (
    <div key={uuidv4()}>
      <Accordion
        title={location.name}
        isOpen={true}
        isNested={true}
        count={`${location.totalAiItems}/${location.totalItems}`}
      >
        <div className={style.equipmentsWrapper}>
          {location.equipment_models?.length &&
            location.equipment_models.map((equipment) => (
              <EquipmentCard key={uuidv4()} equipmentInfo={equipment} keyData={keyData} />
            ))}
        </div>
      </Accordion>
    </div>
  ));
};

export default HardwareEquipmentsByLoc;
